import React from "react";
import { HeroSection } from "../components/HeroSection";
import { ValuesBanner } from "../components/ValuesBanner";
import { PartnerLogos } from "../components/PartnerLogos";
// import { AfricanTalentShowcase } from '../components/AfricanTalentShowcase';
// import { ImpactMetrics } from '../components/ImpactMetrics';
import { ServicesOverview } from "../components/ServicesOverview";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { CallToAction } from "../components/CallToAction";

export const Home = () => {
  return (
    <div className="pt-20 lg:pt-32">
      <HeroSection />
      <ValuesBanner />
      <PartnerLogos />
      <ServicesOverview />
      {/* <AfricanTalentShowcase /> */}
      <TestimonialsSection />
      {/* <ImpactMetrics /> */}
      <CallToAction />
    </div>
  );
};
